<template>
  <v-container class="pt-10">
    <apexchart
      type="donut"
      :options="options"
      :series="data"
      @dataPointSelection="handleClick"
      length="350px"
      height="350px"
    ></apexchart>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: ['data', 'labels', 'subtitle', 'customOptions'],
  methods: {
    handleClick(event, chartContext, config) {
      let divId = ''; let
        i = 0;

      while (i < 15) {
        if (event.path[i].id === 'network-health' || event.path[i].id === 'network-health-chart') {
          divId = event.path[i].id;
          break;
        }
        i += 1;
      }
      let groupId;
      if (divId === 'network-health') {
        groupId = this._filter.group;
      } else if (divId === 'network-health-chart') {
        groupId = this.$router.currentRoute.params.id;
        console.log(this.$router, this.$router.currentRoute.params, 'router');
      }

      if (this._currentClient.client_name === 'shark' && divId) {
        const filterColorOptions = {
          0: 'Green',
          1: 'Yellow',
          2: 'Red'
        };
        this.$router.push({ path: '/shark/screens/',
          query: {
            networkHealthFilter: filterColorOptions[config.dataPointIndex],
            networkHealthFilterGroup: groupId

          } });
      }
    }
  },
  computed: {
    ...mapGetters({
      _options: 'charts/getDonutChart',
      _currentClient: 'account/getCurrentClient',
      _filter: 'filters/getFilter',
    }),
    options() {
      const options = { ...this._options };
      options.labels = this.labels;
      if (this.customOptions && this.customOptions.colors) {
        options.colors = this.customOptions.colors;
      }
      return options;
    },
  },
};
</script>
